import { AggregationData } from '../types';
import { dispatchRegionInfo } from './dispatch-region-info';
import {
  getGameHelpData,
  getGameWindowData,
} from './parse-aggregation-game-window-data';
import dispatchGameContext from './dispatch-game-context';
import { useStore } from '@/store/useStore';
import { dispatchSWJData } from '../swj/dispatch-swj-data';
import { dispatchExperiments } from './dispatch-experiments';

const handleAggregationData = (
  aggregationData: AggregationData,
  gameUid: string,
) => {
  const { platform } = useStore.getState().runtime;

  const { regionInfo, gameWindow } = aggregationData ?? {};
  const { gameInfo, data } = gameWindow ?? {};
  const swjData = aggregationData?.gameWindow?.jackpotData;
  const features = aggregationData?.gameWindow?.features;
  if (!regionInfo) {
    throw new Error('[DATA_FETCH] No regionInfo received');
  }

  dispatchExperiments(aggregationData?.experiments);
  dispatchRegionInfo(regionInfo);
  dispatchSWJData(swjData, features);

  if (!gameInfo) {
    throw new Error('[DATA_FETCH] No gameInfo received');
  }

  dispatchGameContext({
    gameWindowData: getGameWindowData(data),
    gameHelpData: getGameHelpData(data),
    gameInfo: {
      ...gameInfo,
      gameUid,
      platform,
    },
  });
};

export default handleAggregationData;
